import React from 'react'
import ReCAPTCHA from "react-google-recaptcha";

let i = 1;
let vector = [];
let vector_2 = [1];
let vector_3 = [];

for(i = 1; i<= cantCart;i++) {
    vector[i]=i;
}

let id_f = 0;
let product_id = '';
let version_id = 0;
let img = '';
let name = '';
let version = '';
let price = 0;
let cant = '';
let subtotal = 0;
let totally = 0;
let envio = 0;
let counter = 0;
let contAddres = 1;

const Info = function info ({products_cart,products,form,onChange,onSubmit,recaptchaRefCart,onChangeCity,cities,shipping,plusMore,plusLess,deleteG,goShop,addressList,changeAddress,onSubmitAddress,formAddress,onChangeAddress,onChangeAddressCity,selectAddress,
    onSubmitAddressAdd,formAddressAdd,onChangeAddressAdd,onChangeAddressCityAdd,
    city_id
}){
    return (
        <main>
            <div className="back flex w90">
                <a href={https} className="flex">
                <img src={https+"img/back.svg"} alt="⬅"/>
                <span>Atrás</span>
                </a>
            </div>

            <div className="titCart colflex w90">
                <h3>Tu carrito de compras</h3>
                <p>Tienes {cantCart} item en tu carrito</p>
            </div>

            <section className="cart">
                <div className="container colflex w90">
                <div className="listCart colflex">
                    {vector.map((v) => {
                        if (products.length == undefined) {
                            if(products[v] != undefined){
                                counter = counter + 1;
                                id_f=parseInt(counter);
                                if(products[v].id != ''){
                                    id_f = products[v].id;
                                }else{
                                    id_f = 0
                                }
                                vector_3[id_f]=id_f;
                                if(products[v].product_id != ''){
                                    product_id = products[v].product_id;
                                }else{
                                    product_id = ''
                                }
                                if(products[v].version_id != ''){
                                    version_id = products[v].version_id;
                                }else{
                                    version_id = 0
                                }
                                if(products[v].img != ''){
                                    img = products[v].img;
                                }else{
                                    img = ''
                                }
                                if(products[v].name != ''){
                                    name = products[v].name;
                                }else{
                                    name = ''
                                }
                                if(products[v].version != ''){
                                    version = products[v].version;
                                }else{
                                    version = ''
                                }
                                if(products[v].price != ''){
                                    price = products[v].price;
                                }else{
                                    price = 0
                                }
                                if(products[v].cant != ''){
                                    cant = products[v].cant;
                                }else{
                                    cant = ''
                                }
                                if(products[v].subtotal != ''){
                                    subtotal = products[v].subtotal;
                                }else{
                                    subtotal = 0
                                }
                                price = new Intl.NumberFormat().format(price);
                                price = price.replace(/,/g , ".");
                                return(
                                    <div className="item colflex relative" key={v}>
                                        <div className='img'>
                                            <div>
                                                <img src={https+img} className="imgCart" alt="product"/>
                                            </div>
                                        </div>
                                        <div className="detailItem colflex">
                                            <h4>{name}</h4>
                                            <span>{version}</span>
                                            <p>${price}</p>
                                            <div className="flex">
                                                <img
                                                className="minus" 
                                                src={https+"img/minus.svg"} alt="-" 
                                                id={"plusless_"+id_f}
                                                product_id={product_id}
                                                version_id={version_id}
                                                onClick={() => plusLess(vector_3[v])}/>
                                                <span 
                                                id={"cant_"+id_f}>{cant}</span>
                                                <img 
                                                className="plus" 
                                                src={https+"img/plus.svg"} 
                                                alt="+" 
                                                id={"plusmore_"+id_f}
                                                product_id={product_id}
                                                version_id={version_id}
                                                onClick={() => plusMore(vector_3[v])}
                                                />
                                                <a className='updateCantCart'>
                                                    Presionar para Actualizar Cantidad
                                                </a>
                                            </div>
                                        </div>
                                        <img 
                                        id={"delete_"+id_f}
                                        onClick={() => deleteG(vector_3[v])} 
                                        product_id={product_id}
                                        version_id={version_id}
                                        src={https+"img/bin.svg"} 
                                        alt="🗑" 
                                        className="removeItem absolute"
                                        />
                                    </div>
                                )
                                }
                            }
                        }
                    )}
                </div>
                <div className="payCart colflex">
                    <div className="subTotal colflex">
                    {vector_2.map((v) => {
                        if(addressList.length > 0){
                            return (
                                <div className="flex address">
                                    <p style={{
                                        textAlign: 'center',
                                        width: '100%'
                                        }}>
                                        Seleccionar Dirección
                                    </p>
                                    <a rel="modal:open" 
                                        href="#userAddressAdd"
                                        className='iconAdd'
                                    >
                                        <img src={https+'img/add-icon.svg'}/>
                                    </a>
                                </div>
                            )
                        }
                    })}
                    {addressList.map((a)=>{
                        if(contAddres == 1){
                            contAddres = 2;
                            setTimeout(function(){
                                //$('#click_address_'+a.id).click();
                                $("#address_"+a.id).prop('checked', true);
                                changeAddress(a.id,a.city);
                            },1000);
                        }
                        return (
                            <div className="flex address">
                                <p>
                                    <input
                                        name="address_id"
                                        value={a.id}
                                        type="checkbox"
                                        id={"address_" + a.id} 
                                        className="address_list"
                                        onClick={() => changeAddress(a.id,a.city)}
                                    />
                                    <label 
                                        onClick={() => changeAddress(a.id,a.city)}
                                        for={"address_" + a.id}
                                    >
                                        {a.address}
                                    </label>
                                </p>
                                <a onClick={() => selectAddress(a.id)} rel="modal:open" href="#userAddress">
                                    <img src={https+'img/edit.svg'}/>
                                </a>
                            </div>
                        )
                    }
                    )}
                    <div className="flex">     
                        {vector_2.map((v) => {

                            if(subtotal > 0){ 

                                if(nameUser != ''){
                                    if(city_id == 4242){
                                        totally = subtotal+parseInt(shipping);
                                    }else{
                                        totally = subtotal;
                                    }
                                    
                                    subtotal = new Intl.NumberFormat().format(subtotal);
                                    subtotal = subtotal.replace(/,/g , ".");

                                    envio = new Intl.NumberFormat().format(shipping);
                                    envio = envio.replace(/,/g , ".");
                                    
                                    totally = new Intl.NumberFormat().format(totally);
                                    totally = totally.replace(/,/g , ".");
                                }else{
                                    totally = subtotal;
                                    
                                    subtotal = new Intl.NumberFormat().format(subtotal);
                                    subtotal = subtotal.replace(/,/g , ".");
                                    
                                    totally = new Intl.NumberFormat().format(totally);
                                    totally = totally.replace(/,/g , ".");
                                }
                            }
                        })}
                        <p>Subtotal</p>
                        <span>${subtotal}</span>
                    </div>
                    <div className="flex">
                        <p>Envío</p>
                        {vector_2.map((v) => {
                            if(nameUser != ''){
                                if(city_id == 4242){
                                    return <span>${envio}</span>
                                }else{
                                    return <span>Pago a contraentrega </span>
                                }
                            }else{
                                return <span>Se calcula al continuar</span>
                            }    
                          }
                        )}
                    </div>
                    </div>
                    <div className="total colflex">
                    <div className="flex">
                        <p>Total</p>
                        <span>${totally}</span>
                    </div>
                    
                    {vector_2.map((v) => {
                            if(nameUser != ''){
                                return <a onClick={()=>goShop()}>Comprar ahora</a>
                            }else{
                                return <a  rel="modal:open" href="#userCart">Continuar Compra</a>
                            }    
                        }
                    )}
                    {vector_2.map((v) => {
                            if(nameUser == ''){
                                return (
                                    <a rel="modal:open" href="#userModal" className="flex_button">
                                        Iniciar Sesion
                                    </a>
                                )
                            }
                        }
                    )}
                    <a href={https+"shop"} className="flex">
                        Seguir comprando
                        <img src={https+"img/arrow.svg"} alt="➡"/>
                    </a>
                    </div>
                </div>
                </div>
            </section>

            <div className="modal userModal" id="userCart">
                <div className="container colflex">
                    <div className="tittle">
                        <h3>Datos de compra y despacho</h3>
                    </div>
                    <form id="formCart" action="" onSubmit={onSubmit}>
                        <ReCAPTCHA
                            ref={recaptchaRefCart}
                            size="invisible"
                            sitekey="6LfcjZ0fAAAAAEqsOPo6f6Cmw9e2din9S2TxcM7m"
                        />
                        <input
                            type="text"
                            name="name"
                            placeholder="Nombre"
                            value={form.name}
                            onChange={onChange}
                        />
                        <input
                            type="text"
                            name="lastname"
                            placeholder="Apellido"
                            value={form.lastname}
                            onChange={onChange}
                        />
                        <input 
                            type="text" 
                            placeholder="Ingresa tu Cedula (opcional)"
                            name="identy"
                            value={form.identy}
                            onChange={onChange}    
                        />
                        <input
                            type="text"
                            name="mail"
                            placeholder="Correo electronico"
                            value={form.mail}
                            onChange={onChange}
                        />
                        <input
                            type="text"
                            name="phone"
                            placeholder="Teléfono"
                            value={form.phone}
                            onChange={onChange}
                        />
                        <input 
                            type="text" 
                            placeholder="Ingresa tu Direccion"
                            name="address"
                            value={form.address}
                            onChange={onChange}           
                        />
                        <select
                            name="city_id"
                            onChange={onChangeCity}
                        >
                            <option>Selecciona tu Ciudad</option>
                            {cities.map((c) => (
                                <option value={c.CiuCodigo} key={c.CiuCodigo}>{c.CiuNombre}</option>
                            ))}
                        </select>
                        <input 
                            type="text" 
                            placeholder="Ingresa tu Barrio"
                            name="town"
                            value={form.town}
                            onChange={onChange}
                        />
                        <textarea
                            name="description"
                            value={form.description}
                            onChange={onChange}
                            placeholder='Detalles adicionales de la dirrecion...'
                        ></textarea>
                        <div className="policy">
                            <p>*Al continuar con la compra autorizas el <a target="_blank" href={https+'terms'}>uso y tratamiento de datos.</a></p>
                        </div>
                        <button type="submit">
                            <a className="initSession">
                                Continuar
                            </a>
                        </button>
                    </form>
                </div>
            </div>

            <div className="modal userModal" id="userAddress">
                <div className="container colflex">
                    <div className="tittle">
                        <h3>
                            Editar Dirección
                        </h3>
                    </div>
                    <form id="formAddress" action="" onSubmit={onSubmitAddress}>
                        <input 
                            type="text"
                            placeholder="Ingresa tu Direccion"
                            name="address"
                            value={formAddress.address}
                            onChange={onChangeAddress}           
                        />
                        <select
                            name="city_id"
                            onChange={onChangeAddressCity}
                        >
                            <option>Selecciona tu Ciudad</option>
                            {cities.map((c) => {
                                if(formAddress.city_id == c.CiuCodigo){
                                    return (
                                        <option selected value={c.CiuCodigo} key={c.CiuCodigo}>{c.CiuNombre}</option>
                                    )  
                                }else{
                                    return (
                                        <option value={c.CiuCodigo} key={c.CiuCodigo}>{c.CiuNombre}</option>
                                    )  
                                }                         
                            }    
                            )}
                        </select>
                        <input 
                            type="text" 
                            placeholder="Ingresa tu Barrio"
                            name="town"
                            value={formAddress.town}
                            onChange={onChangeAddress}
                        />
                        <input 
                            type="password" 
                            placeholder="Ingresa tu Contraseña"
                            name="password"
                            value={formAddress.password}
                            onChange={onChangeAddress}           
                        />
                        <textarea
                            name="description"
                            value={formAddress.description}
                            onChange={onChangeAddress}
                            placeholder='Detalles adicionales de la dirrecion...'
                        ></textarea>
                        <button type="submit">
                            <a className="initSession">
                                Actualizar Dirección
                            </a>
                        </button>
                    </form>
                </div>
            </div>

            <div className="modal userModal" id="userAddressAdd">
                <div className="container colflex">
                    <div className="tittle">
                        <h3>
                            Agregar Dirección
                        </h3>
                    </div>
                    <form
                        id="formAddressAdd" 
                        action="" 
                        onSubmit={onSubmitAddressAdd}
                    >
                        <input 
                            type="text"
                            placeholder="Ingresa tu Direccion"
                            name="address"
                            value={formAddressAdd.address}
                            onChange={onChangeAddressAdd}           
                        />
                        <select
                            name="city_id"
                            onChange={onChangeAddressCityAdd}
                        >
                            <option>Selecciona tu Ciudad</option>
                            {cities.map((c) => {
                                return (
                                    <option value={c.CiuCodigo} key={c.CiuCodigo}>{c.CiuNombre}</option>
                                )                       
                            }    
                            )}
                        </select>
                        <input 
                            type="text" 
                            placeholder="Ingresa tu Barrio"
                            name="town"
                            value={formAddressAdd.town}
                            onChange={onChangeAddressAdd}
                        />
                        <input 
                            type="password" 
                            placeholder="Ingresa tu Contraseña"
                            name="password"
                            value={formAddressAdd.password}
                            onChange={onChangeAddressAdd}           
                        />
                        <textarea
                            name="description"
                            value={formAddressAdd.description}
                            onChange={onChangeAddressAdd}
                            placeholder='Detalles adicionales de la dirrecion...'
                        ></textarea>
                        <button type="submit">
                            <a className="initSession">
                                Guardar Dirección
                            </a>
                        </button>
                    </form>
                </div>
            </div>

        </main>
    )
}

export default Info